import { useLayoutEffect, useState } from 'react';
import { Position } from 'reactflow';

import styled from 'styled-components';

import { StyledHandle } from 'ui/journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

type ActionType = 'ghost';

const GhostSourceHandle = styled(StyledHandle).attrs({
  type: 'source',
  id: 'source-handle',
})({
  visibility: 'hidden',
});

const GhostTargetHandle = styled(StyledHandle).attrs({
  type: 'target',
  id: 'target-handle',
})({
  visibility: 'hidden',
});

export const Node = (node: TravellerJourneyNode<ActionType>) => {
  const [height, setHeight] = useState(0);
  const originalNode = node.id.split('-ghost')[0];
  useLayoutEffect(() => {
    const observer = new ResizeObserver((entries) => {
      setHeight(entries[0].contentRect.height);
    });
    const el = document.querySelector(`[data-id="${originalNode}"]`);
    if (!el) return;
    observer.observe(el);
  }, [originalNode]);

  return (
    <div style={{ visibility: 'hidden', width: 1, height }}>
      <GhostSourceHandle position={node.sourcePosition ?? Position.Bottom} />
      <GhostTargetHandle position={node.targetPosition ?? Position.Top} />
    </div>
  );
};
